module.exports = __webpack_public_path__ + "img/interface_tracks.e1b04a25.png";